"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingApiSupplierResponseDto = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const billing_api_account_response_dto_1 = require("../../../billing-api-account/types/dtos/billing-api-account-response.dto");
const transform_iso8601_date_1 = __importDefault(require("../../../../shared/pipes/transform-iso8601-date"));
const swagger_1 = require("../../../../swagger-fake");
const types_1 = require("../../../billing-api-contractor/types");
const billing_api_payout_response_dto_1 = require("../../../billing-api-payout/types/dtos/billing-api-payout-response.dto");
const billing_core_payout_type_enum_1 = require("../../../../billing-core/billing-core-payout/types/enums/billing-core-payout-type.enum");
const billing_core_supplier_status_enum_1 = require("../../../../billing-core/billing-core-supplier/types/enums/billing-core-supplier-status.enum");
const billing_core_payout_methods_enum_1 = require("../../../../billing-core/billing-core-payout/types/enums/billing-core-payout-methods.enum");
const billing_api_supplier_merchant_response_dto_1 = require("./billing-api-supplier-merchant-response.dto");
const billing_api_supplier_dto_1 = require("./billing-api-supplier.dto");
let BillingApiSupplierResponseDto = class BillingApiSupplierResponseDto extends billing_api_supplier_dto_1.BillingApiSupplierDto {};
__decorate([(0, swagger_1.ApiProperty)({
  description: "Id поставщика",
  format: "uuid"
}), (0, class_validator_1.IsUUID)(4), (0, class_transformer_1.Expose)(), __metadata("design:type", String)], BillingApiSupplierResponseDto.prototype, "id", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Текущий счёт для выплат используемый в данный момент данным контрагентом у данного провайдера",
  type: () => billing_api_account_response_dto_1.BillingApiAccountResponseDto
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsOptional)(), (0, class_transformer_1.Type)(() => billing_api_account_response_dto_1.BillingApiAccountResponseDto), __metadata("design:type", Object)], BillingApiSupplierResponseDto.prototype, "payoutAccount", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Статус верификации",
  enum: billing_core_supplier_status_enum_1.BillingCoreSupplierStatusEnum
})
//@IsEnum(BillingCoreSupplierStatusEnum)
, (0, class_validator_1.IsOptional)(), (0, class_transformer_1.Expose)(), __metadata("design:type", Object)], BillingApiSupplierResponseDto.prototype, "status", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Активен",
  type: "boolean"
}), (0, class_validator_1.IsBoolean)(), (0, class_transformer_1.Expose)(), __metadata("design:type", Boolean)], BillingApiSupplierResponseDto.prototype, "isActive", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Основная валюта",
  type: "string",
  example: "USD"
}), (0, class_validator_1.IsString)(), (0, class_validator_1.Length)(3, 3), (0, class_transformer_1.Expose)(), __metadata("design:type", String)], BillingApiSupplierResponseDto.prototype, "currencyCode", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Доступный для вывода баланс",
  type: String,
  format: "decimal",
  example: "100.00"
}), (0, class_transformer_1.Expose)(), __metadata("design:type", String)], BillingApiSupplierResponseDto.prototype, "balance", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Сумма полученных авансов за услуги которые ещё предстоит оказать",
  type: String,
  format: "decimal",
  example: "100.00"
}), (0, class_transformer_1.Expose)(), __metadata("design:type", String)], BillingApiSupplierResponseDto.prototype, "advancesBalance", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Баланс ожидающий разморозки по завершению периода оспаривания",
  type: String,
  format: "decimal",
  example: "100.00"
}), (0, class_transformer_1.Expose)(), __metadata("design:type", String)], BillingApiSupplierResponseDto.prototype, "upcomingBalance", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Доступный для вывода баланс в начиональной валюте",
  type: String,
  format: "decimal",
  example: "100.00"
}), (0, class_transformer_1.Expose)(), __metadata("design:type", String)], BillingApiSupplierResponseDto.prototype, "balanceLocal", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Сумма полученных авансов  в начиональной валюте за услуги которые ещё предстоит оказать",
  type: String,
  format: "decimal",
  example: "100.00"
}), (0, class_transformer_1.Expose)(), __metadata("design:type", String)], BillingApiSupplierResponseDto.prototype, "advancesBalanceLocal", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Баланс  в начиональной валюте ожидающий разморозки по завершению периода оспаривания",
  type: String,
  format: "decimal",
  example: "100.00"
}), (0, class_transformer_1.Expose)(), __metadata("design:type", String)], BillingApiSupplierResponseDto.prototype, "upcomingBalanceLocal", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Минимальная сумма вывода в долларах",
  type: String,
  format: "decimal",
  example: "100.00"
}), (0, class_transformer_1.Expose)(), __metadata("design:type", String)], BillingApiSupplierResponseDto.prototype, "minimalPayout", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Доступные методы выплат",
  enum: billing_core_payout_methods_enum_1.BillingCorePayoutMethodEnum,
  isArray: true
}), (0, class_transformer_1.Expose)(), __metadata("design:type", Array)], BillingApiSupplierResponseDto.prototype, "payoutMethodsAvailable", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Доступные схемы выплат",
  enum: billing_core_payout_type_enum_1.BillingCorePayoutTypeEnum,
  isArray: true
}), (0, class_transformer_1.Expose)(), __metadata("design:type", Array)], BillingApiSupplierResponseDto.prototype, "payoutTypesAvailable", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Дата создания поставщика",
  format: "date-time"
}), (0, transform_iso8601_date_1.default)(), (0, class_validator_1.IsDate)(), (0, class_transformer_1.Expose)(), __metadata("design:type", Date)], BillingApiSupplierResponseDto.prototype, "createdAt", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Дата обновления поставщика",
  format: "date-time"
}), (0, transform_iso8601_date_1.default)(), (0, class_validator_1.IsDate)(), (0, class_transformer_1.Expose)(), __metadata("design:type", Date)], BillingApiSupplierResponseDto.prototype, "updatedAt", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Информация о интеграции с мерчант-провайдером",
  type: () => billing_api_supplier_merchant_response_dto_1.BillingApiSupplierMerchantResponseDto,
  nullable: true,
  required: false
}), (0, class_transformer_1.Expose)(), __metadata("design:type", Object)], BillingApiSupplierResponseDto.prototype, "merchant", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Контрагент",
  type: () => types_1.BillingApiContractorResponseDto
}), (0, class_validator_1.IsOptional)(), (0, class_transformer_1.Type)(() => types_1.BillingApiContractorResponseDto), (0, class_transformer_1.Expose)(), __metadata("design:type", Object)], BillingApiSupplierResponseDto.prototype, "contractor", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Выплаты в процессе",
  type: () => [billing_api_payout_response_dto_1.BillingApiPayoutResponseDto]
}), (0, class_validator_1.IsOptional)(), (0, class_validator_1.IsArray)(), (0, class_transformer_1.Type)(() => billing_api_payout_response_dto_1.BillingApiPayoutResponseDto), (0, class_transformer_1.Expose)(), __metadata("design:type", Object)], BillingApiSupplierResponseDto.prototype, "payouts", void 0);
BillingApiSupplierResponseDto = __decorate([(0, class_transformer_1.Exclude)()], BillingApiSupplierResponseDto);
exports.BillingApiSupplierResponseDto = BillingApiSupplierResponseDto;
